var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"select-case-page"},[_c('SelectCasePageContent'),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }